import React, { useState, useEffect } from "react";
import styled from "styled-components";
import config from "../config";

const DictStyle = styled.div`
  padding: 5px 20px;
  width: 100%;
  margin: auto;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  min-height: 100vh;
`;

const DictGrid = styled.div`
  padding: 5px 20px;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 10px 50px;
  width: 100%;
`;

const TableGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 5px 30px;
  width: 100%;
  border-bottom: 1px solid #ccc;
`;

const Row = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 5px 0;
  border-bottom: 1px solid #ddd;
`;

const Dictionary = () => {
  const [dictData, setDictData] = useState([]);
  const [selectedDict, setSelectedDict] = useState(null);
  const [loading, setLoading] = useState(true);
  const [loadingError, setLoadingError] = useState(false);

  useEffect(() => {
    fetch(`${config.API_BASE_URL}/dictionary`)
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.json();
      })
      .then((data) => {
        setDictData(data);
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
        setLoadingError(true);
      });
  }, []);

  const handleClick = (dictId) => {
    setLoading(true);
    setLoadingError(false);

    fetch(`${config.API_BASE_URL}/dictionary/${dictId}`)
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.json();
      })
      .then((data) => {
        setSelectedDict(data);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        setLoadingError(true);
      });
  };

  // TODO move to lambda
  const getArticle = (tes) => {
    const articles = { 11: "el", 12: "la", 13: "los", 14: "las", 15: "un", 16: "una", 17: "unos", 18: "unas" };
    return articles[tes] ? `<i>${articles[tes]}</i> ` : "";
  };

  return (
    <DictStyle>
      {selectedDict ? (
        <div>
          <div align="center"><a href="#" onClick={() => setSelectedDict(null)}>powrót</a></div><br/>
          <h5>{selectedDict.dict_title_pl} - {selectedDict.dict_title_es}</h5>
          <TableGrid>
              {selectedDict.items.map((item, index) => (
                <Row key={index}>
                  <span><b>{item.tpl === 9 ? item.pl : item.pl}</b></span>
                  <span dangerouslySetInnerHTML={{ __html: (item.tpl === 9 ? "<b>" : "") + getArticle(item.tes) + item.es + (item.tpl === 9 ? "</b>" : "") }}></span>
                </Row>
              ))}
          </TableGrid>
        </div>
      ) : (
        <>
          <h5>Słowniki</h5><p>Dostępne kategorie w słowniku:</p>
          {loading ? (
            <p><b>Dane są ładowane ...</b></p>
          ) : loadingError ? (
            <p><b>Przepraszamy, wystąpił problem przy wczytywaniu</b></p>
          ) : (
            <DictGrid>
              {dictData.map((dict) => (
                <li key={dict.dictionary_id}>
                  <a href="#" onClick={() => handleClick(dict.dictionary_id)}><b>{dict.dictionary_pl}</b></a> - {dict.dictionary_es}
                </li>
              ))}
            </DictGrid>
          )}
        </>
      )}
    </DictStyle>
  );
};

export default Dictionary;